import React from "react";

const About: React.FC = () => {
  return (
    <section id="about" className="about">
      <div className="section-title" data-aos="fade-up">
        {/* Removed About heading for cleaner look */}
      </div>
      <div
        className="about-main-row"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 32,
          alignItems: "flex-start",
          justifyContent: "center",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <div
          className="about-img-col"
          data-aos="fade-right"
          style={{ flex: "1 1 280px", maxWidth: 340, minWidth: 220 }}
        >
          <div style={{ textAlign: "left", marginBottom: 24 }}>
            <img
              src="/assets/img/my-profile-img-3.jpg"
              className="img-fluid"
              alt="Profile"
              style={{
                borderRadius: "1rem",
                maxWidth: "100%",
                marginBottom: 18,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                objectFit: "cover",
                objectPosition: "20% center",
              }}
            />
            <div
              className="contact-info"
              style={{
                marginTop: 12,
                textAlign: "left",
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                padding: 24,
              }}
            >
              <div
                className="info-item"
                style={{
                  marginBottom: 12,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <span
                  className="info-label"
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "#666",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "4px",
                  }}
                >
                  City:
                </span>
                <span
                  className="info-value"
                  style={{
                    fontSize: "0.95rem",
                    color: "#333",
                    fontWeight: 500,
                  }}
                >
                  Eindhoven, Netherlands
                </span>
              </div>
              <div
                className="info-item"
                style={{
                  marginBottom: 12,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <span
                  className="info-label"
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "#666",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "4px",
                  }}
                >
                  Degree:
                </span>
                <a
                  href="https://www.tue.nl/en/education/graduate-school/master-data-science-and-artificial-intelligence"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="info-value"
                  style={{
                    fontSize: "0.95rem",
                    color: "#333",
                    fontWeight: 500,
                    textDecoration: "none",
                    transition: "color 0.3s ease",
                  }}
                >
                  MSc Data Science & Artificial Intelligence
                </a>
              </div>
              <div
                className="info-item"
                style={{
                  marginBottom: 12,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <span
                  className="info-label"
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "#666",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "4px",
                  }}
                >
                  Languages:
                </span>
                <span
                  className="info-value"
                  style={{
                    fontSize: "0.95rem",
                    color: "#333",
                    fontWeight: 500,
                  }}
                >
                  English (Bilingual), Tamil (Bilingual) Spanish (Intermediate),
                  Dutch (Basic)
                </span>
              </div>
              <div
                className="info-item"
                style={{
                  marginBottom: 12,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <span
                  className="info-label"
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "#666",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "4px",
                  }}
                >
                  Email:
                </span>
                <a
                  href="mailto:sibikarthik1@gmail.com"
                  className="info-value"
                  style={{
                    fontSize: "0.95rem",
                    color: "#333",
                    fontWeight: 500,
                    textDecoration: "none",
                    transition: "color 0.3s ease",
                  }}
                >
                  sibikarthik1@gmail.com
                </a>
              </div>
              <div
                className="info-item"
                style={{
                  marginBottom: 12,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <span
                  className="info-label"
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "#666",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "4px",
                  }}
                >
                  LinkedIn:
                </span>
                <a
                  href="https://www.linkedin.com/in/sibi-karthik-c-v/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="info-value"
                  style={{
                    fontSize: "0.95rem",
                    color: "#333",
                    fontWeight: 500,
                    textDecoration: "none",
                    transition: "color 0.3s ease",
                  }}
                >
                  linkedin.com/in/sibi-karthik-c-v
                </a>
              </div>
              <div
                className="info-item"
                style={{
                  marginBottom: 12,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <span
                  className="info-label"
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "#666",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "4px",
                  }}
                >
                  GitHub:
                </span>
                <a
                  href="https://github.com/sibi15"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="info-value"
                  style={{
                    fontSize: "0.95rem",
                    color: "#333",
                    fontWeight: 500,
                    textDecoration: "none",
                    transition: "color 0.3s ease",
                  }}
                >
                  github.com/sibi15
                </a>
              </div>
              <div
                className="info-item"
                style={{
                  marginBottom: 12,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <span
                  className="info-label"
                  style={{
                    fontSize: "0.85rem",
                    fontWeight: 600,
                    color: "#666",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    marginBottom: "4px",
                  }}
                >
                  Phone:
                </span>
                <span
                  className="info-value"
                  style={{
                    fontSize: "0.95rem",
                    color: "#333",
                    fontWeight: 500,
                  }}
                >
                  +31 6 87661900
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          className="about-text-col"
          data-aos="fade-left"
          style={{ flex: "2 1 400px", minWidth: 280, maxWidth: 650 }}
        >
          <div
            className="about-card"
            style={{
              borderRadius: 18,
              boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
              padding: 32,
              marginBottom: 24,
            }}
          >
            <h3
              style={{ fontWeight: 700, marginBottom: 16, fontSize: "1.3rem" }}
            >
              Summary
            </h3>
            <p style={{ color: "#555", fontSize: "1.1rem", marginBottom: 18 }}>
              I'm an AI/ML Engineer and Data Scientist specializing in computer
              vision, statistical modelling, and real-time perception systems.
              Alongside my Master's in Data Science and Artificial Intelligence
              at TU Eindhoven, I've been contributing to Tech United Eindhoven
              (8x RoboCup World Champion team) to develop strategy frameworks
              and vision pipelines for autonomous humanoid soccer robots. My
              work focuses on building intelligent systems that solve complex
              technical challenges, from automated damage detection (93.7%
              accuracy) to real-time object tracking and environmental
              monitoring.
            </p>
            <p style={{ color: "#555", fontSize: "1.1rem", marginBottom: 18 }}>
              I'm also an FA Level 2 (UEFA 'C') licensed football coach,
              currently serving as one of the head coaches at E.S.V.V.
              Pusphaira. Coaching enhances my leadership and strategic thinking,
              while complementing my technical work.
            </p>
            <div style={{ marginTop: 24 }}>
              <h4
                style={{
                  fontWeight: 600,
                  marginBottom: 10,
                  fontSize: "1.3rem",
                }}
              >
                Technical Expertise
              </h4>
              <ul
                style={{
                  color: "#444",
                  fontSize: "1.02rem",
                  marginLeft: 18,
                  lineHeight: 1.7,
                }}
              >
                <li>
                  <strong>Deep Learning & Neural Networks:</strong> CNN
                  architectures (ResNet, DenseNet, VGG), YOLOv8 for real-time
                  object detection, ensemble methods, and transfer learning for
                  computer vision tasks achieving 93%+ accuracy.
                </li>
                <li>
                  <strong>Computer Vision & Robotics:</strong> End-to-end vision
                  pipelines using OpenCV and PyTorch for autonomous perception,
                  ball tracking, multi-object detection, and ROS 2–based
                  multi-agent coordination in robotics systems.
                </li>
                <li>
                  <strong>Production ML & Cloud Deployment:</strong> Scalable
                  machine learning pipelines using TensorFlow/Keras, PyTorch,
                  AWS SageMaker, and CUDA optimization for low-latency inference
                  and cloud-native solutions.
                </li>
                <li>
                  <strong>Data Science & Statistical Modelling:</strong>{" "}
                  Advanced statistical analysis, hypothesis testing, predictive
                  modeling, feature engineering, and data-driven optimization
                  for precision engineering and sports analytics.
                </li>
                <li>
                  <strong>Core Technologies:</strong> Python, PyTorch,
                  TensorFlow, Keras, Git, Docker, AWS (SageMaker, EC2), CUDA,
                  OpenCV, NumPy, Pandas, Scikit-learn, SQL, R
                </li>
              </ul>
            </div>
            <div style={{ marginTop: 24 }}>
              <h4
                style={{
                  fontWeight: 600,
                  marginBottom: 10,
                  fontSize: "1.3rem",
                }}
              >
                Certifications & Achievements
              </h4>
              <ul
                style={{
                  color: "#444",
                  fontSize: "1.02rem",
                  marginLeft: 18,
                  lineHeight: 1.7,
                }}
              >
                <li>NVIDIA Certified Associate - Generative AI LLMs (2026)</li>
                <li>
                  Machine Learning Specialization - Stanford Online & Coursera
                  (2026)
                </li>
                <li>AWS Certified Cloud Practitioner (2023)</li>
                <li>
                  Sports Performance Analytics Specialization - University of
                  Michigan (2023)
                </li>
                <li>
                  FA Level 1 & 2 in Coaching Football (UEFA 'C' License) (2023)
                </li>
              </ul>
            </div>
          </div>
          {/* White space between summary and resumes */}
          <div style={{ height: 16 }}></div>
          {/* Resume Card Section - just below summary, inside about-text-col */}
          <div
            className="about-card resume-card"
            style={{
              borderRadius: 18,
              boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
              padding: 32,
              maxWidth: 650,
              width: "100%",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <a
                href="/Sibi_CS_Resume_1.pdf"
                download
                style={{
                  display: "inline-block",
                  padding: "12px 28px",
                  background: "#333",
                  color: "#fff",
                  borderRadius: 8,
                  fontWeight: 600,
                  fontSize: "1.08rem",
                  textDecoration: "none",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                  textAlign: "center",
                }}
              >
                Download Resume (Technical)
              </a>
              <a
                href="/Sibi_FB_Resume.pdf"
                download
                style={{
                  display: "inline-block",
                  padding: "12px 28px",
                  background: "#333",
                  color: "#fff",
                  borderRadius: 8,
                  fontWeight: 600,
                  fontSize: "1.08rem",
                  textDecoration: "none",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  transition: "all 0.3s ease",
                  textAlign: "center",
                }}
              >
                Download Resume (Football)
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
